'use memo';

import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';

const getProgressTestId = (text: string) =>
  `bc-progress-${text.toLowerCase().replaceAll(' ', '-')}`;

export const renderProgress = (text: string, isComplete: boolean) => (
  <AgxSpacer direction="horizontal" fill className="blankContractProgress">
    <span className="blankContractProgressText">
      <AgxTypography
        id={getProgressTestId(text)}
        type="body_ui"
        size="small"
      >
        {text}
      </AgxTypography>
    </span>
    <span
      className={`blankContractProgressValue ${isComplete ? 'complete' : 'pending'}`}
    >
      <AgxTypography
        id={`${getProgressTestId(text)}-status`}
        type="body_ui"
        size="small"
        color="inherit"
      >
        {isComplete ? 'complete' : 'pending'}
      </AgxTypography>
    </span>
  </AgxSpacer>
);
